/**
 * This file is part of DNG
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 *
 * @author Nicolò Martini <nicmartnic@gmail.com>
 */
require(["common"], function() {
    
	require(["jquery", "URIjs/URI"], function($, URI) {

		$(document).ready(function () {
			/* For result list:
			 * init buttonsets, expand abstract links
			 * and sublev expand button
			 */
			if ($("#result-list").length > 0) {

				$(".abs-content").expander({
					slicePoint: 500,
					widow: 4,
					expandEffect: 'show',
					expandText: ss.i18n._t('Catalog.READALL'),
					userCollapseText: ss.i18n._t('Catalog.CLOSE')
				});
			}

			//Handle facets dropdowns
			$('.lqFacetMultiselect').change(function(event) {
				window.location.replace($(this).val());
			});

			//Handle facets checkboxes
			$('.lqFacetsCheckboxes').find('input[type=checkbox]').change(function(event) {
				window.location.replace($(this).attr('name'));
			});

			/**
			 * Saved searches
			 */
			var retrieveSearchData = function(innerElement) {
				innerElement = innerElement || $("[data-search-type]");
				return {
					"search-query-string": $(innerElement).closestData('query-string'),
					"search-sort": $(innerElement).closestData('search-sort'),
					"type": $(innerElement).closestData('search-type'),
					"search-page-id": $(innerElement).closestData('page-id')
				};
			};

			$('body').on('click', '.savesearch-button', function(event) {
				event.preventDefault();
				$(this).trigger('search-dialog-requested', [retrieveSearchData(this)]);
			});


			$('body').on('click', '.savedsearch-overwrite', function(event) {
				event.preventDefault();
				var data = retrieveSearchData(this);
				data.id = $(this).closestData('shelfid');

				$(this).trigger('search-dialog-requested', [data]);
			});

			$('body').on('searches-updated', function() {
				 $('.savesearch-btn-group').trigger('refresh');
			});

			/**
			 * Handle linked searches...
			 */
			var linkedSearches = $('[data-dng-linkedsearch]');
			var linkedSearchesWrapper = $('.linkedSearchesWrapper');

			if (linkedSearches.length){

				linkedSearchesWrapper.find('[data-dng-action="loading"]').setLoading();

				linkedSearches.each(function(index, element){
					var infoUrl = $(element).data('dng-linkedsearch');

					jQuery.ajax({
						url: infoUrl,
						dataType: 'json',
						success: function ( data ) {
							$(element).find('.numFound').text('('+data.num_found+')');
							if (data.num_found <= 0){
								$(element).css("color","#999");
								$(element).find('a').replaceWith( $(element).text() );
							}
							$(element).fadeIn("slow");
						}
					});

				});
			}


			/**
			 * External searches
			 */
			$('.externalSearches').trigger('refresh');
                        
			$('.externalWidgetsSearches').trigger('refresh');
                        
			$('body').on('refreshed', '.externalSearches', function() {
                            $(this).fadeIn("slow");
			});
                        
			$('body').on('refreshed', '.externalWidgetsSearches', function() {
                            $(this).fadeIn("slow");
			});                        

			$('body').on('click', '.mlol-popup', function(event) {
                            event.preventDefault();
                            if ($('body').hasClass('user-unlogged')) {
                                $(this).trigger('loginmodal-requested');
                                event.stopImmediatePropagation();
                            } else {
                                var src = $(this).data('mlolurl')
                                window.open(src);
                            }
			});

			$('.user-unlogged').tooltip({
                            selector: ".externalSearches",
                            trigger:  Modernizr.touch ? "click" : "hover",
                            title: $('body').data('needs-login-msg')
			});
                        
			$('body').on('dngShowHide', '.externalSearches', function(event) {
                            var opened = $('.externalSearches a[data-dng-state=showed]');
                            if (opened.length > 0) {
                                $('.externalSearches').addClass('expanded');
                            } else {
                                $('.externalSearches').removeClass('expanded');
                            }
			});
                        
			$('body').on('dngShowHide', '.externalWidgetsSearches', function(event) {
                            var opened = $('.externalSearches a[data-dng-state=showed]');
                            if (opened.length > 0) {
                                $('.externalWidgetsSearches').addClass('expanded');
                            } else {
                                $('.externalWidgetsSearches').removeClass('expanded');
                            }
			});

			// Facets navigation
			var updateFacetModalData = function(name, value) {
				var element = $('#facets-modal').find('[data-uri]');
				element.attr('data-' + name, value);
			};

			var reloadFacetModal = function(){
				var element = $('#facets-modal').find('[data-uri]');
				$('#facets-modal').find('.loading-holder').attr('data-isloading', 1);

				var uri = new URI(element.data('uri'));

				uri.setSearch({
					"facet_page": element.attr('data-page'),
					"facet_sort": element.attr('data-sort'),
					"facet_prefix": element.attr('data-prefix')
				});

				element.data('uri', uri.toString());
				element.trigger('refresh');
			};

			$('body').on('click', '.show_more a', function(event) {
				event.preventDefault();

				//Set loading state
				$(this).closest('li').attr('data-isloading', 1);

				var modal = $('#facets-modal');
				var uri = $(this).closestData('facetlist-uri');

				updateFacetModalData('sort', 'count');
				updateFacetModalData('page', '1');
				updateFacetModalData('prefix', '');

				modal.find('[data-uri]')
					.data('uri', uri)
					.html('')
					.trigger('refresh')
				;
			});

			$('body').on('refreshed', '#facets-modal', function() {
				$(this).modal('show');

				//Trick to move the caret at the end of the input value:
				var prefixInput = $(this).find('input[data-action="prefix"]');
				var oldPrefixVal = prefixInput.val();
				$(this).find('input[data-action="prefix"]').focus().val("").val(oldPrefixVal);
			});

			$('body').on('shown.bs.modal', '#facets-modal', function() {
				$('.show_more[data-isloading]').removeAttr('data-isloading');
			});

			//Facets modal controls
			$('body').on('click', '#facets-modal [data-action="previous"]', function(e) {
				e.preventDefault();
				updateFacetModalData('page', parseInt($(this).closestData('page')) - 1);
				reloadFacetModal();
			});
			$('body').on('click', '#facets-modal [data-action="next"]', function(e) {
				e.preventDefault();
				updateFacetModalData('page', parseInt($(this).closestData('page')) + 1);
				reloadFacetModal();
			});

			$('body').on('click', '#facets-modal [data-action="sort-count"]', function() {
				updateFacetModalData('sort', 'count');
				updateFacetModalData('page', '1');
				reloadFacetModal();
			});
			$('body').on('click', '#facets-modal [data-action="sort-index"]', function() {
				updateFacetModalData('sort', 'index');
				updateFacetModalData('page', '1');
				reloadFacetModal();
			});

			$('body').on('input', '#facets-modal [data-action="prefix"]', function() {
				updateFacetModalData('prefix', $(this).val());
				updateFacetModalData('page', '1');
				reloadFacetModal();
			});
                        
                        var updateAuthModalData = function(name, value) {
                            var element = $('#authority-modal').find('[data-uri]');
                            element.attr('data-' + name, value);
			};

			var reloadAuthModal = function(){
                            var element = $('#authority-modal').find('[data-uri]');
                            $('#authority-modal').find('.loading-holder').attr('data-isloading', 1);

                            var uri = new URI(element.data('uri'));

                            uri.setSearch({
                                "auth_page": element.attr('data-page'),
                                "auth_sort": element.attr('data-sort'),
                                "auth_prefix": element.attr('data-prefix'),
                                "auth_id": element.attr('data-id'),
                                "auth_count": element.attr('data-count'),
                                "auth_fulltext": element.attr('data-fulltext'),
                                "auth_initialtext": element.attr('data-initialtext'),
                                "modal_type": element.attr('data-modaltype'),
                                "auth_type": $("#selectorAuthList option:selected").val()
                            });

                            element.data('uri', uri.toString());
                            element.trigger('refresh');
			};
                        
                        /* Sul CLICK di ALTRI SOGGETTI */
			$('body').on('click', '#authOtherSubjectFullExpander', function(event) {
                            event.preventDefault(); 

                            /* Aggiunge il loading... */
                            $(this).closest('a').attr('data-isloading', 1);

                            /* Estrapola l'uri necessario alla chiamata */
                            var authModal = $('#authority-modal');
                            var authUri = $(this).closestData('authlist-uri');

                            /* Aggiunge l'indirizzo ed esegue il refresh */
                            authModal.find('[data-uri]').data('uri', authUri).html('').trigger('refresh');
			});                        
                        
                        /* Sul CLICK di troppi THESAURO */
			$('body').on('click', '#authOtherThesauroOthersExpander', function(event) {
                            event.preventDefault(); 

                            /* Aggiunge il loading... */
                            $(this).closest('a').attr('data-isloading', 1);

                            /* Estrapola l'uri necessario alla chiamata */
                            var authModal = $('#authority-modal');
                            var authUri = $(this).closestData('authlist-uri');

                            /* Aggiunge l'indirizzo ed esegue il refresh */
                            authModal.find('[data-uri]').data('uri', authUri).html('').trigger('refresh');
			});
                        
                        /* Sul CLICK di LISTA AUTHORITY */
			$('body').on('click', '#authorityListModal', function(event) {
                            event.preventDefault(); 

                            /* Aggiunge il loading... */
                            $(this).closest('a').attr('data-isloading', 1);

                            /* Estrapola l'uri necessario alla chiamata */
                            var authModal = $('#authority-modal');
                            var authUri = $(this).closestData('authlist-uri');

                            /* Aggiunge l'indirizzo ed esegue il refresh */
                            authModal.find('[data-uri]').data('uri', authUri).html('').trigger('refresh');
			});                        

        		$('body').on('refreshed', '#authority-modal', function() {
                            $(this).modal('show');

                            //Trick to move the caret at the end of the input value:
                            var authPrefixInput = $(this).find('input[data-action="prefix"]');
                            var authOldPrefixVal = authPrefixInput.val();
                            $(this).find('input[data-action="prefix"]').focus().val("").val(authOldPrefixVal);
			});

                        /* Rimuove il loading alla fine, dopo aver... */
			$('body').on('shown.bs.modal', '#authority-modal', function() {
                            $('#authOtherSubjectFullExpander[data-isloading]').removeAttr('data-isloading');
                            $('#authorityListModal[data-isloading]').removeAttr('data-isloading');
                            $('#authOtherThesauroOthersExpander[data-isloading]').removeAttr('data-isloading');
			});

			/* Paginatori */
			$('body').on('click', '#authority-modal [data-action="previous"]', function(e) {
				e.preventDefault();
				updateAuthModalData('page', parseInt($(this).closestData('page')) - 1);
				reloadAuthModal();
			});
			$('body').on('click', '#authority-modal [data-action="next"]', function(e) {
				e.preventDefault();
				updateAuthModalData('page', parseInt($(this).closestData('page')) + 1);
				reloadAuthModal();
			});

			$('body').on('click', '#authority-modal [data-action="sort-search"]', function() {
				updateAuthModalData('fulltext', $('.text-input-full').val());
                                updateAuthModalData('initialtext', $('.text-input-initial').val());
				updateAuthModalData('page', '0');
				reloadAuthModal();
			});
                        
                        $('body').on('keypress', '#initialtextButton', function(event) {
                            var keycode = (event.keyCode ? event.keyCode : event.which);
                            if(keycode == '13'){
				updateAuthModalData('fulltext', $('.text-input-full').val());
                                updateAuthModalData('initialtext', $('.text-input-initial').val());
				updateAuthModalData('page', '0');
				reloadAuthModal();	
                            }
                        });
                        
                        $('body').on('keypress', '#fulltextButton', function(event) {
                            var keycode = (event.keyCode ? event.keyCode : event.which);
                            if(keycode == '13'){
				updateAuthModalData('fulltext', $('.text-input-full').val());
                                updateAuthModalData('initialtext', $('.text-input-initial').val());
				updateAuthModalData('page', '0');
				reloadAuthModal();	
                            }
                        });                        
		});
	});
});
define("resultpage", function(){});

